import {
	ORGANIZATIONS_GET,
	ORGANIZATIONS_ERROR,
	ORG_INFO_GET,
	ORG_INFO_ERROR,
	WORKSPACES_GET,
	WORKSPACES_ERROR,
	ORG_FILTERS_SET
} from '../actions/types';

const initialState = {
	organizations: [],
	organization_info: {},
	workspaces: [],
	org_filters: {},
	organization_errors: {}
}

export default function organizationReducer(state = initialState, action){
	switch (action.type) {
		case ORGANIZATIONS_GET:
			return {
				...state,
				organizations: action.payload
			}
		case ORG_INFO_GET:
			return {
				...state,
				organization_info: action.payload
			}
		case WORKSPACES_GET:
			return {
				...state,
				workspaces: action.payload
			}
		case ORG_FILTERS_SET:
			return {
				...state,
				org_filters: action.payload
			}
		case ORGANIZATIONS_ERROR:
		case ORG_INFO_ERROR:
		case WORKSPACES_ERROR:
			return {
				...state,
				organization_errors: {
					...state.organization_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
